import { TipoEspacioI } from "interfaces/TipoEspacio";
import { TituloI } from "interfaces/Titulo";
import { ReactNode, useState } from "react";

interface Props {
  elemento: TipoEspacioI;
  renderActions?: (elemento: TipoEspacioI) => ReactNode;
}

export const TipoEspacioRow = ({ elemento, renderActions }: Props) => {
  return (
    <>
      <tr className="table-row" key={`ResolucionTable-${elemento.id}`}>
        <td>{elemento.id}</td>
        <td>{elemento.nombre}</td>
        <td>{elemento.con_sub_tipo ? "Si" : "No"}</td>
        {renderActions && (
          <td style={{ maxWidth: "50px" }}>{renderActions(elemento)}</td>
        )}
      </tr>
    </>
  );
};
